import OverviewSVG from "../../../../src/content/early-years/svg/early-years-graph-1.svg";
import * as React from 'react';
export default {
  OverviewSVG,
  React
};